import {useEffect} from 'react'
import {TenantEditModalHeader} from './TenantEditModalHeader'
import {TenantEditModalFormWrapper} from './TenantEditModalFormWrapper'

const TenantEditModal = () => {
  useEffect(() => {
    document.body.classList.add('modal-open')
    return () => {
      document.body.classList.remove('modal-open')
    }
  }, [])

  return (
    <>
      <div
        className='modal fade show d-block'
        id='kt_modal_add_tenant'
        role='dialog'
        tabIndex={-1}
        aria-modal='true'
      >
        {/* begin::Modal dialog */}
        <div className='modal-dialog modal-dialog-centered mw-850px'>
          {/* begin::Modal content */}
          <div className='modal-content'>
            <TenantEditModalHeader />
            {/* begin::Modal body */}
            <div className='modal-body scroll-y mx-5 px-2 mx-xl-5 '>
              <TenantEditModalFormWrapper />
            </div>
            {/* end::Modal body */}
          </div>
          {/* end::Modal content */}
        </div>
        {/* end::Modal dialog */}
      </div>
      {/* begin::Modal Backdrop */}
      <div className='modal-backdrop fade show'></div>
      {/* end::Modal Backdrop */}
    </>
  )
}

export {TenantEditModal}
